var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "#323338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5777",
    "data-name": "Group 5777",
    transform: "translate(-1702 -436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8175",
    "data-name": "Path 8175",
    d: "M4,7A1,1,0,0,1,5,6H21a1,1,0,0,0,0-2H4A2.006,2.006,0,0,0,2,6V17H1.5a1.5,1.5,0,0,0,0,3H14V17H4ZM23,8H17a1,1,0,0,0-1,1V19a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V9A1,1,0,0,0,23,8Zm-1,9H18V10h4Z",
    transform: "translate(1702 432)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItDepartment);
export default __webpack_public_path__ + "static/media/IT_department.ccdd4a5521b7acc1f0ff8362d1ec89eb.svg";
export { ForwardRef as ReactComponent };